import { Injectable, Signal } from '@angular/core';
import { IOfferData, IOfferModel } from '@partners/api';
import { Observable } from 'rxjs';
import { StateAccessService } from '../../../services';
import { IOfferState, OfferActions, OfferSelectors } from '../store';

@Injectable({
  providedIn: 'root'
})
export class OfferStore extends StateAccessService<IOfferState> {
  readonly state$: Observable<IOfferState>;

  readonly data$$: Signal<IOfferData>;
  readonly model$$: Signal<IOfferModel>;

  constructor() {
    super();

    this.model$$ = this.stateFacade.selectSignal$(OfferSelectors.model);
    this.data$$ = this.stateFacade.selectSignal$(OfferSelectors.data);
  }

  dispatchOfferLoad() {
    this.stateFacade.dispatch(OfferActions.load());
  }

  dispatchOfferSubmit() {
    this.stateFacade.dispatch(OfferActions.submit());
  }

  dispatchOfferLoadSuccess({ data }: { data: IOfferData }) {
    this.stateFacade.dispatch(OfferActions.loadSuccess({ data }));
  }

  dispatchOfferSubmitSuccess({ data }: { data: IOfferData }) {
    this.stateFacade.dispatch(OfferActions.submitSuccess({ data }));
  }
}
